import { Product } from "./product";
import { SystemField } from "./system-field";

export class CostHistory extends SystemField{ 
     is_active?:number;
     products_id?:string;
     cost?:number;

     product?:Product;
}
